var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"indexModule adImg1",attrs:{"data":_vm.moduleData.Guid}},[_c('router-link',{attrs:{"to":_vm.moduleData.Link}},[_c('img',{style:({height:_vm.adHeight+'px'}),attrs:{"src":_vm.moduleData.Img}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2406c787","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/mobile/adImg1/adImg1.vue
// module id = null
// module chunks = 